export default __webpack_public_path__ + "static/media/photo--sm--125.b0b2833c.jpg";